export default {
    forms: {},
    files: {},
};
